/***
 *
 *   NAV ITEMS
 *   The left main nav, in order. Screening (feature 011) shows when the
 *   account may run manual screening; Workflows shows when ops have switched
 *   the nav item on and the viewer is an owner, admin or master. Both answers
 *   come from useNavAccess (nav-access.js); this module only arranges them.
 *
 *   PARAMS
 *   access: { screening, workflows } from useNavAccess
 *   permission: the signed-in role's permission row (AuthContext.permission)
 *   signout: the Sign Out action
 *
 **********/

export function buildNavItems({ access, permission, signout } = {}) {
  return [
    { label: "Dashboard", icon: "activity", link: "/dashboard" },
    { label: "Account", icon: "user", link: "/account" },
    { label: "Verification", icon: "check-circle", link: "/direct-verification" },
    ...(access?.screening === true
      ? [{ label: "Screening", icon: "search", link: "/screening" }]
      : []),
    ...(access?.workflows === true && permission?.admin === true
      ? [{ label: "Workflows", icon: "git-merge", link: "/workflow" }]
      : []),
    { label: "Help", icon: "help-circle", link: "/help" },
    { label: "Sign Out", icon: "log-out", action: signout },
  ];
}
